import request from '@/utils/http';

export const getBillDetailsLists = (params) => {
    return request({
        url: `/api-bms-web/efapBill/checkTheBill`,
        method: 'get',
        params
    });
};

export const getBillDetails = (params) => {
    return request({
        url: `/api-bms-web/efapBill/feeTaskHeaderQuery`,
        method: 'get',
        params
    });
};

export const feeApBillQuery = (params) => {
    return request({
        url: `/api-bms-web/efapBill/feeApBillQuery`,
        method: 'get',
        params
    });
};

export const getConfirmBillDetails = (params) => {
    return request({
        url: `/api-bms-web/efapBill/updateBillStatus`,
        method: 'post',
        headers: {
            'Content-Type': 'text/plain'
        },
        data: params
    });
};

export const checkBillRecVer = (params) => {
    return request({
        url: `/api-bms-web/efapBill/checkBillRecVer`,
        method: 'post',
        data: params
    });
};

export const getUpdateAllStatus = (params) => {
    return request({
        url: `/api-bms-web/efapBill/updateAllStatus`,
        method: 'post',
        data: params
    });
};

export const getBillElectronicSignature = (data) => {
    return request({
        url: `/api-bms-web/efapBill/electricSign`,
        method: 'post',
        data
    });
};

// 电子签章撤回
export const getElectronicWithdrawal = (data) => {
    return request({
        url: `/api-bms-web/efapBill/recallApElectronic`,
        method: 'post',
        data
    });
};

// 发票识别
export const getInvoiceUpload = (data) => {
    return request({
        url: `/api-bms-web/efapBill/invoiceUpload`,
        method: 'post',
        isBypassErrHandling: true,
        data
    });
};
// 发票保存
export const saveInvoice = (data) => {
    return request({
        url: `/api-bms-web/efapBill/saveInvoice`,
        method: 'post',
        data
    });
};

// 发票删除
export const getDeleteUpload = (data) => {
    return request({
        url: `/api-bms-web/efapBill/deleteInvoice`,
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data
    });
};

// 寄出
export const getInvoiceOperation = (data) => {
    return request({
        url: `/api-bms-web/efapBill/invoiceOperation`,
        method: 'post',
        data
    });
};

// 发票上传
export const getFileUpload = (data) => {
    return request({
        url: `/api-bms-web/efapBill/fileUpload`,
        method: 'post',
        data
    });
};

// 发票上传-重新查验
export const getAfreshCheck = (data) => {
    return request({
        url: `/api-bms-web/efapBill/afreshCheck`,
        method: 'post',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        data
    });
};

export const getFillLists = (params) => {
    return request({
        url: `/api-bms-web/efApInvoiceHeader/queryInvoiceInfo`,
        method: 'get',
        params
    });
};

// 发票信息-删除
export const getRemoveLists = (params) => {
    return request({
        url: `/api-bms-web/efApInvoiceHeader/removeEfApInvoice`,
        method: 'get',
        params
    });
};

// 记录打印次数
export const getRecordPrinting = (data) => {
    return request({
        url: `/api-bms-web/efapBill/recordPrint`,
        method: 'post',
        data
    });
};

// 网点信息
export const getNetworkInfos = (params) => {
    return request({
        url: `/api-bms-web/feeTask/getNetworkInfos`,
        method: 'get',
        params
    });
};

// 合同标签页
export const getSuContract = (params) => {
    return request({
        url: '/api-bms-web/efapBill/getSuContract',
        method: 'get',
        params
    });
};

// 核销项信息
export const getqueryChargeOff = (params) => {
    return request({
        url: `/api-bms-web/apApply/queryChargeOff`,
        method: 'get',
        params
    });
};
export const getApApplyListApDetail = (params) => {
    return request({
        url: `/api-bms-web/apApply/listApDetail`,
        method: 'get',
        params
    });
};

export const getApBillDeDetail = (params) => { // 新增  网点/运配 信息
    return request({
        url: `/api-bms-web/efapBill/getApBillDeDetail`,
        method: 'get',
        params
    });
};

export const getApBillDetail = (params) => { // 费用明细
    return request({
        url: `/api-bms-web/efapBill/getApBillDetail`,
        method: 'get',
        params
    });
};
export const getSaveApBillDetail = (data) => { // 保存网点/运配信息
    return request({
        url: `/api-bms-web/efapBill/saveApBillDetail`,
        method: 'post',
        data
    });
};
export const getSupplierFineDebitQuery = (params) => { // 票前扣款页签
    return request({
        url: `/api-bms-web/efapBill/supplierFineDebitQuery`,
        method: 'get',
        params
    });
};
export const getUploadApBillDetail = (data) => { // 上传 核对费用导入
    return request({
        url: `/api-bms-web/efapBill/uploadApBillDetail`,
        method: 'post',
        data
    });
};
export const getExportTaskDetail = (params) => { // 上传 核对费用导出
    return request({
        url: `/api-bms-web/efapBill/exportTaskDetail`,
        method: 'get',
        responseType: 'arraybuffer',
        params
    });
};
export const getExportTask = (data) => { // 上传 核对费用导出
    return request({
        url: `/api-lcp-report/report/task/export`,
        method: 'post',
        data
    });
};
export const getBatchSaveApBillDetail = (params) => { // 批量确认费用
    return request({
        url: `/api-bms-web/efapBill/batchSaveApBillDetail`,
        method: 'get',
        params
    });
};
export const getPageEiOtpEtdoFrozen = (params) => { // 司机确认收款明细
    return request({
        url: `/api-bms-web/efapBill/pageEiOtpEtdoFrozen`,
        method: 'get',
        params
    });
};
